import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { debounce } from '@mui/material';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { ListDate } from 'services/commonDate_services';
import { BC5Response, ListKeynValue } from 'services/report_services';
import { AiOutlineBarChart, AiOutlineDownload } from 'react-icons/ai';
import moment from 'moment';
import CustomSelect from 'base/ui/components/CustomSelect';
import { ActionType, ProColumns, ProTable } from '@ant-design/pro-components';
import { formatNumber } from 'utils/formatHelper';
import CustomProTable from 'base/ui/components/CustomTable';
import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import { Button, Checkbox, DatePicker, Radio, RadioChangeEvent } from 'antd';
import SearchCollapse from '../reportComponents/searchCollapse';
import Wrapper from 'base/ui/components/Wrapper';
import { commonDatePresenter, commonDateStore, reportPresenter, reportStore } from 'stores/root_store';
import TemplateReportModal from 'base/ui/components/Modal/TemplateReportModal';
import { useResizableColumns } from 'utils/reportHelper';
import dayjs from 'dayjs';
import { CheckboxValueType } from 'antd/es/checkbox/Group';

// data dropdown tình trạng hàng
const statusMachine = [
  {
    key: 'null',
    value: 'Tất cả',
  },
  {
    key: 'true',
    value: 'Còn sử dụng',
  },
  {
    key: 'false',
    value: 'Ngưng sử dụng',
  },
];

//Chọn loại
const loai = [
  {
    key: 'HĐ',
    value: 'Hoạt động',
  },
  {
    key: 'NM',
    value: 'Ngưng máy',
  },
];

// Chọn loại hoạt động
const loaiHoatDong = [
  {
    key: 'SX',
    value: 'Sản xuất',
  },
  {
    key: 'CM',
    value: 'Canh máy',
  },
  {
    key: 'VS',
    value: 'Vệ sinh',
  },
];

// data dropdown mức độ
const level = [
  {
    key: 'CHUYEN',
    value: 'Xem theo barcode máy/chuyền',
  },
  {
    key: 'MAY',
    value: 'Xem chi tiết theo máy',
  },
];

export function createMachineUptime() {
  return observer(() => {
    //=======================================================================
    //======================================================================= REGISTER ZONE
    //=======================================================================
    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
      tuNgay: undefined as string | undefined,
      denNgay: undefined as string | undefined,
      type: 'TH' as 'TH' | 'CT' | 'CT2',
      mucDo: 'CHUYEN' as 'CHUYEN' | 'MAY',
      tinhTrang: undefined as boolean | undefined,
      mayChuyens: [] as string[],
      nhomMayChuyens: [] as string[],
      phanXuongs: [] as string[],
      loai: [] as string[],
      loaiHoatDong: [] as string[],
      isHasRecord: true as boolean | null,
      phanLoai: ['Chain', 'Machine', 'Outsource'] as string[],
    });

    // dòng tính tổng
    const [dataSummary, setDataSummary] = useState<BC5Response[]>([]);

    // data chart
    const [dataCharts, setDataCharts] = useState<
      {
        name: string;
        value: number;
      }[]
    >([]);

    const [dataTable, setDataTable] = useState<BC5Response[]>([]);

    //----COMMON DATA--------------------------------------------------------------------------------------------- //
    // phân xưởng
    const [listPhanXuong, setListPhanXuong] = useState<ListKeynValue[]>([]);
    // Máy/chuyền
    const [listEquip, setListEquip] = useState<ListKeynValue[]>([]);
    // nhóm  Máy/ nhóm chuyền
    const [listGroupEquip, setListGroupEquip] = useState<ListKeynValue[]>([]);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //

    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);
    //loading page when reload
    const [isLoading, setIsLoading] = useState(true);
    // Kiểm tra call xong  api lấy ngày picked date
    const [isReady, setIsReady] = useState(false);
    // hiển thị row tổng cộng
    const [showTotal, setShowTotal] = useState(true);
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<String>();

    //lay ten mot cot [header]
    const [colName, setColName] = useState('Tổng cộng');
    //lay picked date
    const [pickedDate, setpickedDate] = useState<string>('Today');

    const [showChart, setShowChart] = useState(true);
    // ẩn nút show chart khi xem  chi tiết theo ngày (BA yêu cầu)
    const [hiddenBtnShow, setHiddenBtnShow] = useState(false);

    const setBGColorChart = ['#9BC2E6', '#C6E0B4', '#F4B084', '#FFD966'];

    //=======================================================================
    //======================================================================= DATA RESPONSE ZONE
    //=======================================================================
    // các row trong table lấy từ store

    const label = ['HĐ trong giờ', 'HĐ ngoài giờ', 'Ngưng máy ', 'Trống '];
    //========================================================================================================== //
    //-------------------------------------CÁC HÀM GET DATA DÙNG CHUNG-------------------------------------------//
    //========================================================================================================== //

    //  lấy danh sách phân xưởng
    const getDropdownWorkshop = async () => {
      await reportPresenter.getListWorkShop(reportStore);
      if (reportStore.listKeynValue.isSuccess) {
        setListPhanXuong(reportStore.listKeynValue.data);
      }
    };

    // Lấy danh sách máy/chuyền
    const getListEquipment = async (data?: object) => {
      await reportPresenter.getBC07ListEquipcard(reportStore, data ? data : {});
      if (reportStore.listKeynValue.isSuccess) {
        setListEquip(reportStore.listKeynValue.data);
      }
    };

    //debounce Lấy danh sách máy/chuyền
    const debounceListEquipcard = useCallback(debounce(getListEquipment, 300), []);
    // Lấy danh sách nhóm máy/ nhóm chuyền
    const getListGroupEquipment = async (phanXuong?: string[]) => {
      await reportPresenter.getListGroupEquip(reportStore, phanXuong || []);
      if (reportStore.listKeynValue.isSuccess) {
        setListGroupEquip(reportStore.listKeynValue.data);
      }
    };

    const getDateCommonDate = async () => {
      await commonDatePresenter.getListCommonDate(commonDateStore);
      setCommonDate(commonDateStore.listDate.data);
    };

    // lấy ngày từ commonDate
    const getDateByKey = async (key: string) => {
      await commonDatePresenter.getDataByCommonDate(commonDateStore, key);
      if (commonDateStore.commonDate) {
        setDataSearch({
          ...dataSearch,
          tuNgay: commonDateStore.commonDate.fromDate !== '' ? commonDateStore.commonDate.fromDate : undefined,
          denNgay: commonDateStore.commonDate.toDate !== '' ? commonDateStore.commonDate.toDate : undefined,
        });
      }
    };

    // lấy data
    const getDataBC05 = async (data = dataSearch) => {
      if (data.type !== 'CT2') {
        setHiddenBtnShow(false);
      } else {
        setHiddenBtnShow(true);
        setShowChart(false);
      }
      await reportPresenter.getDataBC05(reportStore, data);
      if (
        reportStore.BC05NewResponse.data !== undefined &&
        reportStore.BC05NewResponse.data.bC5Responses.length > 0 &&
        reportStore.BC05NewResponse.data.lineTongCong
      ) {
        const rowSummary: BC5Response = {
          key: 0,
          mayChuyen: 'Tổng cộng',
          // Tổng thời gian định mức
          tongThoiGianDinhMuc: reportStore.BC05NewResponse.data.lineTongCong.tongThoiGianDinhMuc,
          // Tổng thời gian hoạt động
          tongSoGioHoatDong: reportStore.BC05NewResponse.data.lineTongCong.tongSoGioHoatDong,
          tongSoPhutHoatDong: reportStore.BC05NewResponse.data.lineTongCong.tongSoPhutHoatDong,
          tyLeHoatDong: reportStore.BC05NewResponse.data.lineTongCong.tyLeHoatDong,
          // Tổng thời gian hoạt động trong giờ
          tongSoGioHoatDongTrongGio: reportStore.BC05NewResponse.data.lineTongCong.tongSoGioHoatDongTrongGio,
          tongSoPhutHoatDongTrongGio: reportStore.BC05NewResponse.data.lineTongCong.tongSoPhutHoatDongTrongGio,
          tyLeHoatDongTrongGio: reportStore.BC05NewResponse.data.lineTongCong.tyLeHoatDongTrongGio,
          // Tổng thời gian hoạt động ngoài giờ

          tongSoGioHoatDongNgoaiGio: reportStore.BC05NewResponse.data.lineTongCong.tongSoGioHoatDongNgoaiGio,
          tongSoPhutHoatDongNgoaiGio: reportStore.BC05NewResponse.data.lineTongCong.tongSoPhutHoatDongNgoaiGio,
          tyLeHoatDongNgoaiGio: reportStore.BC05NewResponse.data.lineTongCong.tyLeHoatDongNgoaiGio,
          // Tổng thời gian ngưng máy

          tongSoGioNgungMay: reportStore.BC05NewResponse.data.lineTongCong.tongSoGioNgungMay,
          tongSoPhutNgungMay: reportStore.BC05NewResponse.data.lineTongCong.tongSoPhutNgungMay,
          tyLeNgungMay: reportStore.BC05NewResponse.data.lineTongCong.tyLeNgungMay,
          // Tổng thời gian trống

          tongSoGioTrong: reportStore.BC05NewResponse.data.lineTongCong.tongSoGioTrong,
          tongSoPhutTrong: reportStore.BC05NewResponse.data.lineTongCong.tongSoPhutTrong,
          tyLeTrong: reportStore.BC05NewResponse.data.lineTongCong.tyLeTrong,

          tongThoiGianTheoGio: reportStore.BC05NewResponse.data.lineTongCong.tongThoiGianTheoGio,
          tongThoiGianTheoPhut: reportStore.BC05NewResponse.data.lineTongCong.tongThoiGianTheoPhut,
        };
        const data = reportStore.BC05NewResponse.data.bC5Responses;
        setDataSummary([rowSummary]);
        setDataCharts(
          reportStore.BC05NewResponse.data.charts.map((chart) => ({
            name: chart.type,
            value: Number(formatNumber(chart.value, 2)),
          })),
        );
        setDataTable(data);
        return data;
      }
      setDataSummary([]);
      setDataCharts([]);
      setDataTable([]);
      return [];
    };

    const renderTable = () => {
      const columnTable = [...defaultColumn];
      const columnCTTG: ProColumns<BC5Response>[] = [
        {
          title: 'STT',
          dataIndex: 'stt',
          width: 35,
          key: 'stt',
          fixed: 'left',
          render: (text, record) => record.stt,
          onCell: (record) => ({
            style: {
              textAlign: 'center',
            },
          }),
        },
        {
          title: 'Nhóm máy/Nhóm chuyền',
          dataIndex: 'nhomMayNhomChuyen',
          key: 'nhomMayNhomChuyen',
          className: '!py-1',
          width: 200,
          sorter: true,
          render: (text, record) => text,
        },
        {
          title: 'Máy/Chuyền',
          dataIndex: 'mayChuyen',
          key: 'mayChuyen',
          className: '!py-1',
          width: 200,
          sorter: true,
          render: (text, record) => text,
        },
        {
          title: 'Từ',
          dataIndex: 'tu',
          key: 'tu',
          className: '!py-1',
          width: 100,
          render: (text, record) => (text !== null && text !== '-' ? moment(`${text}`).format('DD/MM/YYYY HH:mm') : ''),
          onCell: (record) => ({
            style: {
              textAlign: 'center',
            },
          }),
        },
        {
          title: 'Đến',
          dataIndex: 'den',
          key: 'den',
          className: '!py-1',
          width: 100,
          render: (text, record) => (text !== null && text !== '-' ? moment(`${text}`).format('DD/MM/YYYY HH:mm') : ''),
          onCell: (record) => ({
            style: {
              textAlign: 'center',
            },
          }),
        },
        {
          title: 'Loại',
          dataIndex: 'loai',
          key: 'loai',
          className: '!py-1',
          width: 100,
          sorter: true,
          render: (text, record) => text,
        },
        {
          title: 'Loại hoạt động',
          dataIndex: 'loaiHoatDong',
          key: 'loaiHoatDong',
          className: '!py-1',
          width: 100,
          sorter: true,
          render: (text, record) => text,
        },
        {
          title: 'Lý do ngưng hoạt động',
          dataIndex: 'lyDoNgungMay',
          key: 'lyDoNgungMay',
          className: '!py-1',
          width: 100,
          sorter: true,
          render: (text, record) => text,
        },
        {
          title: 'Ghi chú',
          dataIndex: 'ghiChu',
          key: 'ghiChu',
          className: '!py-1',
          width: 100,
          sorter: true,
          render: (text, record) => text,
        },
        {
          title: 'Tổng Thời gian',
          key: 'tongThoiGian',
          width: 100,
          className: '!py-1',

          children: [
            {
              title: 'Giờ',
              dataIndex: 'tongThoiGianTheoGio',
              width: 100,
              key: 'tongThoiGianTheoGio',
              className: '!py-1',
              render: (text, record) => formatNumber(Number(text), 0),
              onCell: (record) => ({
                style: {
                  textAlign: 'right',
                },
              }),
            },
            {
              title: 'Phút',
              dataIndex: 'tongThoiGianTheoPhut',
              width: 100,
              key: 'tongThoiGianTheoPhut',
              className: '!py-1',
              render: (text, record) => formatNumber(Number(text), 0),
              onCell: (record) => ({
                style: {
                  textAlign: 'right',
                },
              }),
            },
          ],
        },
      ];
      switch (dataSearch.type) {
        case 'TH': {
          setShowChart(true);
          if (dataSearch.mucDo === 'CHUYEN') {
            setShowTotal(true);

            setColumn(columnTable);
          } else if (dataSearch.mucDo === 'MAY') {
            setShowTotal(false);
            columnTable.splice(3, 0, {
              title: 'Máy móc (Chi tiết)',
              dataIndex: 'mayMocChiTiet',
              key: 'mayMocChiTiet',
              className: '!py-1',
              width: 100,
              render: (text, record) => text,
            });
            setColumn(columnTable);
          }
          break;
        }
        case 'CT': {
          setShowChart(true);
          if (dataSearch.mucDo === 'CHUYEN') {
            setShowTotal(true);
            columnTable.splice(3, 0, {
              title: 'Ngày',
              dataIndex: 'ngay',
              key: 'ngay',
              className: '!py-1',
              width: 100,
              render: (text, record) => (record.ngay ? moment(record.ngay).format('DD/MM/YYYY') : ''),
              onCell: (record) => ({
                style: {
                  textAlign: 'center',
                },
              }),
            });
            setColumn(columnTable);
          } else if (dataSearch.mucDo === 'MAY') {
            setShowTotal(false);
            columnTable.splice(
              3,
              0,
              {
                title: 'Máy móc (Chi tiết)',
                dataIndex: 'mayMocChiTiet',
                key: 'mayMocChiTiet',
                className: '!py-1',
                width: 100,
                render: (text, record) => text,
              },
              {
                title: 'Ngày',
                dataIndex: 'ngay',
                key: 'ngay',
                className: '!py-1',
                width: 100,
                render: (text, record) => (record.ngay ? moment(record.ngay).format('DD/MM/YYYY') : ''),
                onCell: (record) => ({
                  style: {
                    textAlign: 'center',
                  },
                }),
              },
            );
            setColumn(columnTable);
          }
          break;
        }
        case 'CT2': {
          setShowTotal(false);
          setShowChart(false);
          if (dataSearch.mucDo === 'CHUYEN') {
            setColumn(columnCTTG);
          } else if (dataSearch.mucDo === 'MAY') {
            columnCTTG.splice(3, 0, {
              title: 'Máy móc (Chi tiết)',
              dataIndex: 'mayMocChiTiet',
              key: 'mayMocChiTiet',
              className: '!py-1',
              width: 100,
              render: (text, record) => text,
            });
            setColumn(columnCTTG);
          }
          break;
        }
      }
    };
    //=======================XXX========================XXX=========================XXX========================= //

    // handle search form
    const onSearch = async () => {
      renderTable();
      setIsLoading(true);
      setDataSearch({ ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } });
      await getDataBC05({ ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } });
      setIsLoading(false);
    };

    // HAM XU LY KHI CLICK VAO SEARCH : THOI GIAN
    const handleChangeListTime = async (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && !Array.isArray(option)) {
        setpickedDate(option.key);
        await getDateByKey(option.key);
      } else {
        setpickedDate('');
        setDataSearch({ ...dataSearch, tuNgay: undefined, denNgay: undefined });
      }
    };

    const handleChangeSelectMul = (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && Array.isArray(option)) {
        setDataSearch({
          ...dataSearch,
          [idKey]: option.map((val) => {
            return val.key;
          }),
        });
      } else {
        setDataSearch({
          ...dataSearch,
          [idKey]: [],
        });
      }
    };

    var option: EChartsOption = (option = {
      //Hiển thị thông tin dữ liệu khi trỏ chuột lên
      tooltip: {
        trigger: 'item',
        borderColor: '#000',
        borderWidth: 0,
        borderRadius: 2,
        shadowOffsetX: 0,
        shadowOffsetY: 1,
        shadowBlur: 2,
        shadowColor: 'rgba(0, 0, 0, 0.25)',
        textStyle: {
          fontSize: 12,
          fontWeight: 400,
        },
        className:
          `echarts-tooltip echarts-tooltip-dark !rounded-[2px] !p-0 [&>div>:nth-child(1)]:font-['Roboto'] [&>div>:nth-child(1)]:bg-red-500 [&>div>:nth-child(1)]:text-[12px]` +
          ` [&>div>:nth-child(1)]:font-medium [&>div>:nth-child(1)]:bg-[#F6F8FB] [&>div>:nth-child(1)]:leading-[22px] [&>div>:nth-child(1)]:leading-[22px] ` +
          `[&>div>:nth-child(1)]:pt-[3px] [&>div>:nth-child(1)]:flex [&>div>:nth-child(1)]:rounded-t-[2px] [&>div>:nth-child(1)]:h-[31px] [&>div>:nth-child(1)]:items-center [&>div>:nth-child(1)]:pl-[7px] [&>div>:nth-child(1)]:pb-[6px] [&>div>:nth-child(1)]:border-b-[1px] ` +
          `[&>div>:nth-child(2)]:p-[10px] [&>div>:nth-child(2)]:pt-[6px] [&>div>:nth-child(2)]:font-['Roboto']`,
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        // containLabel: true,
      },
      // Chú thích tên và màu sắc các danh mục
      legend: {
        // type: windowSize.innerWidth > 1024 ? 'plain' : 'scroll',
        // top: windowSize.innerWidth > 1024 ? 'center' : '0',
        // right: windowSize.innerWidth > 1024 ? '5%' : '0',
        // left: windowSize.innerWidth > 1024 ? 'auto' : 'center',
        // orient: windowSize.innerWidth > 1024 ? 'vertical' : 'horizontal',
        itemGap: 5,
        textStyle: {
          fontFamily: 'Roboto',
          fontSize: 12,
          color: '#77838F',
        },
      },
      color: setBGColorChart,
      series: [
        {
          name: 'Tỷ lệ',
          type: 'pie',
          // radius: ['35%', '75%'],
          avoidLabelOverlap: false,
          // center: [`${windowSize.innerWidth > 1024 ? '35%' : '50%'}`, '55%'],
          itemStyle: {
            // borderRadius: 4,
            // borderColor: '#fff',
            // borderWidth: 2,
          },
          //Hiện thị Tỷ lệ phần trăm từng danh mục
          label: {
            show: true,
            position: 'outside',
            fontWeight: 'bold',
            formatter: '{d}%',
          },
          //Định dạng kích thước chữ của Tỷ lệ khi hover
          emphasis: {
            label: {
              show: true,
              fontSize: 15,
              fontWeight: 'bold',
            },
          },
          //Đường kẻ nối chỉ số Tỷ lệ với lát bánh
          labelLine: {
            show: true,
          },
          labelLayout: {
            hideOverlap: false,
            moveOverlap: 'shiftX',
          },
          data: dataCharts,
        },
      ],
    });

    //=======================================================================
    //======================================================================= USEEFFECT ZONE
    //=======================================================================

    //goi 2 api bang voi date
    useEffect(() => {
      const getDataAPI = async () => {
        // setIsLoading(true);
        await getDateCommonDate();
        await getDateByKey(pickedDate);
        setIsReady(true);
        await getDropdownWorkshop();
        await getListEquipment();
        await getListGroupEquipment();
        setIsLoading(false);
      };
      getDataAPI();
    }, []);

    //========================================================================================================== //
    //-------------------------------------------COLUMN TABLE-------------------------------------------------//
    //========================================================================================================== //
    const defaultColumn: ProColumns<BC5Response>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 35,
        key: 'stt',
        render: (text, record) => (record.stt ? record.stt : ''),
        onCell: (record) => ({
          style: {
            textAlign: 'center',
          },
        }),
        fixed: 'left',
      },
      {
        title: 'Nhóm máy/ Nhóm chuyền',
        dataIndex: 'nhomMayNhomChuyen',
        key: 'nhomMayNhomChuyen',
        className: '!py-1',
        width: 100,
        sorter: true,
        fixed: 'left',
        render: (text, record) => (record.nhomMayNhomChuyen ? record.nhomMayNhomChuyen : ''),
      },
      {
        title: 'Máy/Chuyền',
        dataIndex: 'mayChuyen',
        key: 'mayChuyen',
        className: '!py-1',
        fixed: 'left',
        width: 150,
        sorter: true,
        render: (text, record) => text,
      },

      {
        title: 'Tổng TG định mức (giờ)',
        dataIndex: 'tongThoiGianDinhMuc',
        key: 'tongThoiGianDinhMuc',
        className: '!py-1',
        // fixed: 'left',
        width: 100,
        render: (text, record) => formatNumber(Number(text), 0),
        onCell: (record) => ({
          style: {
            textAlign: 'right',
          },
        }),
      },
      {
        title: 'Tổng TG hoạt động',
        key: 'tongTGHoatDong',
        width: 100,
        className: '!py-1',
        children: [
          {
            title: 'Giờ',
            dataIndex: 'tongSoGioHoatDong',
            width: 60,
            key: 'tongSoGioHoatDong',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
              },
            }),
          },
          {
            title: 'Phút',
            dataIndex: 'tongSoPhutHoatDong',
            width: 60,
            key: 'tongSoPhutHoatDong',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
              },
            }),
          },
          {
            title: 'Tỷ lệ',
            dataIndex: 'tyLeHoatDong',
            width: 60,
            key: 'tyLeHoatDong',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 2) + '%',
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                // backgroundColor: setBGColorChart[0],
              },
            }),
          },
        ],
      },

      {
        title: 'HĐ trong giờ',
        // width: 200,
        key: 'tongTGHoatDongTrongGio',
        className: '!py-1',
        children: [
          {
            title: 'Giờ',
            dataIndex: 'tongSoGioHoatDongTrongGio',
            width: 60,
            key: 'tongSoGioHoatDongTrongGio',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[0],
              },
            }),
          },
          {
            title: 'Phút',
            dataIndex: 'tongSoPhutHoatDongTrongGio',
            width: 60,
            key: 'tongSoPhutHoatDongTrongGio',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[0],
              },
            }),
          },
          {
            title: 'Tỷ lệ',
            dataIndex: 'tyLeHoatDongTrongGio',
            width: 60,
            key: 'tyLeHoatDongTrongGio',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 2) + '%',
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[0],
              },
            }),
          },
        ],
      },
      {
        title: 'HĐ ngoài giờ',
        // width: 200,
        key: 'hoatDong',
        className: '!py-1',
        children: [
          {
            title: 'Giờ',
            dataIndex: 'tongSoGioHoatDongNgoaiGio',
            width: 60,
            key: 'tongSoGioHoatDongNgoaiGio',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[1],
              },
            }),
          },
          {
            title: 'Phút',
            dataIndex: 'tongSoPhutHoatDongNgoaiGio',
            width: 60,
            key: 'tongSoPhutHoatDongNgoaiGio',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[1],
              },
            }),
          },
          {
            title: 'Tỷ lệ',
            dataIndex: 'tyLeHoatDongNgoaiGio',
            width: 60,
            key: 'tyLeHoatDongNgoaiGio',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 2) + '%',
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[1],
              },
            }),
          },
        ],
      },
      {
        title: 'Ngưng máy',
        // width: 200,
        key: 'ngungMay',
        className: '!py-1',
        children: [
          {
            title: 'Giờ',
            dataIndex: 'tongSoGioNgungMay',
            width: 60,
            key: 'tongSoGioNgungMay',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[2],
              },
            }),
          },
          {
            title: 'Phút',
            dataIndex: 'tongSoPhutNgungMay',
            width: 60,
            key: 'tongSoPhutNgungMay',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[2],
              },
            }),
          },
          {
            title: 'Tỷ lệ',
            dataIndex: 'tyLeNgungMay',
            width: 60,
            key: 'tyLeNgungMay',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 2) + '%',
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[2],
              },
            }),
          },
        ],
      },
      {
        title: 'Trống',
        // width: 200,
        key: 'trong',
        className: '!py-1',
        children: [
          {
            title: 'Giờ',
            dataIndex: 'tongSoGioTrong',
            width: 60,
            key: 'tongSoGioTrong',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[3],
              },
            }),
          },
          {
            title: 'Phút',
            dataIndex: 'tongSoPhutTrong',
            width: 60,
            key: 'tongSoPhutTrong',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 0),
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[3],
              },
            }),
          },
          {
            title: 'Tỷ lệ',
            dataIndex: 'tyLeTrong',
            width: 60,
            key: 'tyLeTrong',
            className: '!py-1',
            render: (text, record) => formatNumber(Number(text), 2) + '%',
            onCell: (record) => ({
              style: {
                textAlign: 'right',
                backgroundColor: setBGColorChart[3],
              },
            }),
          },
        ],
      },
    ];
    const [columns, setColumn] = useState<ProColumns<BC5Response>[]>(defaultColumn);

    // Hàm thay đổi độ rộng cột
    const handleResize =
      (index: number, id?: number) =>
      (e: any, { size }: any) => {
        setColumn((prevColumns) => {
          const nextColumns = [...prevColumns];
          nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
            // @ts-ignore
            children: nextColumns[index].children
              ? // @ts-ignore
                nextColumns[index].children.map((child, i) => {
                  if (id === i) {
                    return {
                      ...child,
                      width: size.width,
                    };
                  }
                  return child;
                })
              : undefined,
          };
          return nextColumns;
        });
      };

    //=======================XXX========================XXX=========================XXX========================= //
    //========================================================================================================== //
    //-------------------------------------------MẪU BÁO CÁO-------------------------------------------------//
    //========================================================================================================== //

    const tableRef = useRef<ActionType>();

    const constDataName = 'bc-05';

    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
    } = useResizableColumns<BC5Response>(columns, setColumn, constDataName);
    //=======================XXX========================XXX=========================XXX========================= //

    //=======================================================================
    //======================================================================= RETURN ZONE
    //=======================================================================

    return (
      <div className="w-full py-3 px-5">
        <SearchCollapse title="BC05. BÁO CÁO TỔNG HỢP THỜI GIAN HOẠT ĐỘNG CỦA MÁY/CHUYỀN SẢN XUẤT">
          <form
            onSubmit={handleSubmit(onSearch)}
            className="w-full px-8 py-2 lg:grid lg:grid-cols-2 flex flex-col gap-y-2"
          >
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
              {/* <div className="min-w-[150px] font-bold text-default text-black sm:text-end">
                <label className=" cursor-pointer">Xem dữ liệu theo</label>
              </div>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({
                      ...dataSearch,
                      isHasRecord: e.target.value,
                    });
                  }}
                  value={dataSearch.isHasRecord}
                >
                  <Radio className="!text-default" value={true}>
                    Máy/chuyền có dữ liệu ghi nhận
                  </Radio>
                  <Radio className="!text-default" value={false}>
                    Tất cả
                  </Radio>
                </Radio.Group>
              </div> */}
              <CustomSelect
                title="Xem dữ liệu theo"
                idKey="isHasRecord"
                value={dataSearch.isHasRecord}
                data={[
                  {
                    label: 'Tất cả',
                    value: null,
                  },
                  {
                    label: 'Máy/chuyền có dữ liệu ghi nhận',
                    value: true,
                  },
                  {
                    label: 'Máy/chuyền không có dữ liệu ghi nhận',
                    value: false,
                  },
                ]}
                onChangeValue={(value, option) => {
                  setDataSearch({
                    ...dataSearch,
                    isHasRecord: option.value,
                  });
                }}
              />
            </div>
            {/* Phân xưởng */}
            <div className="w-full sm:items-center grid grid-cols-3 col-start-1">
              <CustomSelect
                mode="multiple"
                title="Phân xưởng"
                data={listPhanXuong}
                // onChangeValue={handleChangeSelectMul}
                onChangeValue={async (value, option) => {
                  if (option && Array.isArray(option)) {
                    const listPS = option.map((val) => {
                      return val.key;
                    });
                    setDataSearch({
                      ...dataSearch,
                      phanXuongs: listPS,
                    });
                    // lấy data nhóm máy
                    getListGroupEquipment(listPS);
                    // gọi lại api lấy data máy
                    getListEquipment({
                      workshopId: listPS,
                      equipmentGrCode: dataSearch.nhomMayChuyens,
                    });
                  } else {
                    setDataSearch({
                      ...dataSearch,
                      phanXuongs: [],
                    });
                    // lấy data nhóm máy
                    getListGroupEquipment();
                    // gọi lại api lấy data máy
                    getListEquipment({
                      workshopId: [],
                      equipmentGrCode: dataSearch.nhomMayChuyens,
                    });
                  }
                }}
                idKey="phanXuongs"
                showSearch
                allowClear
                placeholder="Chọn phân xưởng"
              />
            </div>
            {/* Nhóm máy/nhóm chuyền */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Nhóm máy/nhóm chuyền"
                data={listGroupEquip}
                // onChangeValue={handleChangeSelectMul}
                onChangeValue={async (value, option) => {
                  if (option && Array.isArray(option)) {
                    const listNhomMay = option.map((val) => {
                      return val.key;
                    });
                    setDataSearch({
                      ...dataSearch,
                      nhomMayChuyens: listNhomMay,
                    });

                    // gọi lại api lấy data máy
                    debounceListEquipcard({
                      workshopId: dataSearch.phanXuongs,
                      equipmentGrCode: listNhomMay,
                    });
                  } else {
                    setDataSearch({
                      ...dataSearch,
                      nhomMayChuyens: [],
                    });
                    // lấy data nhóm máy
                    getListGroupEquipment();
                    // gọi lại api lấy data máy
                    debounceListEquipcard({
                      workshopId: dataSearch.phanXuongs,
                      equipmentGrCode: [],
                    });
                  }
                }}
                idKey="nhomMayChuyens"
                showSearch
                allowClear
                placeholder="Chọn nhóm máy/nhóm chuyền"
              />
            </div>
            {/* máy/chuyền */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Máy/chuyền"
                data={listEquip}
                onChangeValue={handleChangeSelectMul}
                idKey="mayChuyens"
                showSearch
                allowClear
                placeholder="Chọn máy/chuyền"
                onSearch={async (value) =>
                  await debounceListEquipcard({
                    equipmentName: value,
                    workshopId: dataSearch.phanXuongs,
                    equipmentGrCode: dataSearch.nhomMayChuyens,
                  })
                }
              />
            </div>
            {/* Mức độ */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">Mức độ</label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({ ...dataSearch, mucDo: e.target.value });
                  }}
                  value={dataSearch.mucDo}
                >
                  {level.map((item) => (
                    <Radio className="!text-default" value={item.key}>
                      {item.value}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            </div>
            {/* Tình trạng máy/chuyền */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Tình trạng máy/chuyền"
                data={statusMachine}
                onChangeValue={(value, option) => {
                  if (option && !Array.isArray(option)) {
                    setDataSearch({ ...dataSearch, tinhTrang: JSON.parse(option.key) });
                  } else {
                    setDataSearch({ ...dataSearch, tinhTrang: undefined });
                  }
                }}
                idKey="tinhTrang"
                allowClear
                placeholder="Chọn tình trạng máy/chuyền"
              />
            </div>
            {/* Phân loại */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">Phân loại</label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Checkbox.Group
                  onChange={(checkedValues: CheckboxValueType[]) => {
                    if (checkedValues.length) setDataSearch({ ...dataSearch, phanLoai: checkedValues as string[] });
                  }}
                  value={dataSearch.phanLoai}
                >
                  <Checkbox className="!text-default" value={'Chain'}>
                    Chuyền sản xuất
                  </Checkbox>
                  <Checkbox className="!text-default" value={'Machine'}>
                    Máy móc
                  </Checkbox>
                  <Checkbox className="!text-default" value={'Outsource'}>
                    Gia công ngoài
                  </Checkbox>
                </Checkbox.Group>
              </div>
            </div>

            {/* Chọn thoi gian */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title=" Thời gian"
                data={commonDate}
                value={commonDate.find((date) => date.key === pickedDate)}
                onChangeValue={handleChangeListTime}
                idKey="pickedDate"
                placeholder="Chọn khoảng thời gian"
              />
            </div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
              <label htmlFor="tuNgay" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Từ ngày
              </label>

              <DatePicker
                id="tuNgay"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={dataSearch.tuNgay ? dayjs(dataSearch.tuNgay) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, tuNgay: pickDate });
                }}
              />
            </div>

            {/* đến ngày */}
            <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3">
              <label htmlFor="denNgay" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Đến ngày
              </label>

              <DatePicker
                id="denNgay"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={dataSearch.denNgay ? dayjs(dataSearch.denNgay) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, denNgay: pickDate });
                }}
              />
            </div>

            {/* Xem theo */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">Xem theo</label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({ ...dataSearch, type: e.target.value });
                  }}
                  value={dataSearch.type}
                >
                  <Radio className="!text-default" value={'TH'}>
                    Tổng hợp
                  </Radio>
                  <Radio className="!text-default" value={'CT'}>
                    Chi tiết theo ngày
                  </Radio>
                  <Radio className="!text-default" value={'CT2'}>
                    Chi tiết theo giờ
                  </Radio>
                </Radio.Group>
              </div>
            </div>
            <div></div>
            {dataSearch.type === 'CT2' && (
              <>
                {/* Loại */}
                <div className="w-full sm:items-center grid grid-cols-3">
                  <CustomSelect
                    mode="multiple"
                    title="Loại"
                    data={loai}
                    onChangeValue={handleChangeSelectMul}
                    idKey="loai"
                    showSearch
                    allowClear
                    placeholder="Chọn loại"
                  />
                </div>
                {/* Loại hoạt động */}
                {/* Hiện loại hoạt động khi chọn 'loại' có 'hoạt động' */}
                {dataSearch.loai.includes('HĐ') && (
                  <div className="w-full sm:items-center grid grid-cols-3">
                    <CustomSelect
                      mode="multiple"
                      title="Loại hoạt động"
                      data={loaiHoatDong}
                      onChangeValue={handleChangeSelectMul}
                      idKey="loaiHoatDong"
                      showSearch
                      allowClear
                      placeholder="Chọn loại hoạt động"
                    />
                  </div>
                )}
              </>
            )}

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2 mb-3">
              <Button
                type="primary"
                loading={isLoading}
                htmlType="submit"
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </form>
        </SearchCollapse>

        <Wrapper>
          {/* =========== Table PO ===============*/}
          <button
            className={`w-7 h-7 border-2 rounded-sm hover:text-primary flex justify-center items-center border-gray-100 ${
              hiddenBtnShow ? 'opacity-0' : 'opacity-100'
            }`}
            onClick={() => setShowChart(!showChart)}
          >
            <AiOutlineBarChart fontSize={'20px'} />
          </button>

          <div className={`my-3.5 grid grid-cols-3 gap-2`}>
            <div
              className={`${
                showChart ? 'col-span-1 max-w-full max-h-fit' : 'max-w-0 max-h-0 grid-cols-none'
              } duration-500`}
            >
              <h2 className={`text-center uppercase whitespace-nowrap ${showChart ? '' : 'scale-0'} duration-500`}>
                {colName}
              </h2>
              <div
                className={`text-default font-bold flex gap-2 w-full justify-center ${
                  showChart ? '' : 'scale-0'
                } duration-500`}
              >
                <span>
                  Từ ngày:{' '}
                  <span className="w-28 inline-block font-normal">
                    {dataSearch.tuNgay && moment(dataSearch.tuNgay).format('DD/MM/YYYY')}
                  </span>
                </span>
                <span>
                  Đến ngày:{' '}
                  <span className="w-28 inline-block font-normal">
                    {dataSearch.denNgay && moment(dataSearch.denNgay).format('DD/MM/YYYY')}
                  </span>
                </span>
              </div>
              <ReactECharts
                option={option}
                className={`${showChart ? 'min-h-[450px] scale-100' : 'scale-0 -translate-y-1/2'} duration-500`}
              />
            </div>

            <div className={`${showChart ? 'col-span-2' : 'col-span-3'}`}>
              {isReady ? (
                <CustomProTable<BC5Response>
                  columns={columns}
                  loading={isLoading}
                  handleResize={handleResize}
                  isResizablePresent={isResizablePresent}
                  resizableColumnSelect={resizableColumnSelect}
                  className="[&_td]:!text-xs [&_td]:!font-medium [&_th]:!text-xs [&_td:nth-child(1)]:!p-0 [&_td]:!p-1 [&_th]:!p-1 [&_.ant-table-measure-row>td]:!p-0"
                  request={async (params = {}, sort, filter) => {
                    setIsLoading(true);

                    const data = await getDataBC05({
                      ...dataSearch,
                      paging: {
                        ...dataSearch.paging,
                        orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                        orderByDesc:
                          Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                      },
                    });
                    if (Object.values(sort).length) {
                      setDataSearch({
                        ...dataSearch,
                        paging: {
                          ...dataSearch.paging,
                          orderBy:
                            Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                          orderByDesc:
                            Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                        },
                      });
                    }
                    setIsLoading(false);
                    return {
                      data: data,
                      success: reportStore.SumaryProductionReportResponse.isSuccess,
                    };
                  }}
                  rowKey={'stt'}
                  dataSource={dataTable.map((data) => data)}
                  actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
                  // columnsState={{
                  //   value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
                  //   onChange: (newColumnsState) => {
                  //     handleColumnsStateChange(newColumnsState);
                  //   },
                  // }}
                  onRow={(data, index) => {
                    return {
                      className: 'cursor-pointer',
                      onClick: (e) => {
                        setColName(data.mayChuyen || '');
                        setDataCharts([
                          {
                            name: label[0],
                            value: data.tyLeHoatDongTrongGio ? Number(formatNumber(data.tyLeHoatDongTrongGio, 2)) : 0,
                          },
                          {
                            name: label[1],
                            value: data.tyLeHoatDongNgoaiGio ? Number(formatNumber(data.tyLeHoatDongNgoaiGio, 2)) : 0,
                          },
                          {
                            name: label[2],
                            value:
                              data.tyLeNgungMay && data.tyLeNgungMay ? Number(formatNumber(data.tyLeNgungMay, 2)) : 0,
                          },
                          {
                            name: label[3],
                            value: data.tyLeTrong && data.tyLeTrong > 0 ? Number(formatNumber(data.tyLeTrong, 2)) : 0,
                          },
                        ]);
                      },
                    };
                  }}
                  pagination={{
                    pageSize: dataSearch.paging.pageSize,
                    total: reportStore.BC05NewResponse.paging?.totalCount,
                    current: dataSearch.paging.pageIndex,
                    responsive: true,
                    pageSizeOptions: [10, 25, 50, 100],
                    showSizeChanger: true,
                    position: ['topRight', 'bottomRight'],
                    style: { margin: '10px 0' },
                    showTotal: (total, range) =>
                      `Hiển thị ${range[0]}-${range[1]} của ${reportStore.BC05NewResponse.paging?.totalCount} mục`,
                    onChange: (page, pageSize) => {
                      setDataSearch({
                        ...dataSearch,
                        paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                      });
                    },
                  }}
                  // scroll={{ scrollToFirstRowOnChange: true, x: 'auto', y: 'auto' }}
                  toolBarRender={() => [
                    <Button
                      size="middle"
                      loading={isLoading}
                      className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                      onClick={async () => {
                        setIsLoading(true);
                        await reportPresenter.exportExcelBC05({ ...dataSearch });
                        setIsLoading(false);
                      }}
                      type="primary"
                    >
                      <AiOutlineDownload className="block text-base" />
                      <span className="block">Export Excel</span>
                    </Button>,
                  ]}
                  summary={(data) => {
                    return showTotal ? (
                      <ProTable.Summary fixed="top">
                        <ProTable.Summary.Row
                          onClick={() => {
                            if (
                              reportStore.BC05NewResponse.data !== undefined &&
                              reportStore.BC05NewResponse.data.bC5Responses.length > 0
                            ) {
                              setColName('Tổng cộng');
                              setDataCharts(
                                reportStore.BC05NewResponse.data.charts.map((chart) => ({
                                  name: chart.type,
                                  value: Number(formatNumber(chart.value, 2)),
                                })),
                              );
                            }
                          }}
                        >
                          <ProTable.Summary.Cell index={1} colSpan={100} className="!bg-[#0a497d]">
                            {dataSummary.length ? (
                              <CustomProTable<BC5Response>
                                className={
                                  '[&_td]:!border-none [&_.ant-table-container]:!border-none [&_td]:!bg-gradient-to-r [&_td]:!from-[#0a497d] [&_td]:!to-[#0a497d] [&_td]:!text-white'
                                }
                                columns={columns}
                                options={false}
                                showHeader={false}
                                rowKey={'key'}
                                scroll={{ scrollToFirstRowOnChange: false, x: 'auto', y: 'auto' }}
                                handleResize={handleResize}
                                isResizablePresent={isResizablePresent}
                                resizableColumnSelect={resizableColumnSelect}
                                dataSource={dataSummary}
                                pagination={false}
                              />
                            ) : (
                              ''
                            )}
                          </ProTable.Summary.Cell>
                        </ProTable.Summary.Row>
                      </ProTable.Summary>
                    ) : undefined;
                  }}
                />
              ) : (
                <CustomProTable<BC5Response>
                  loading={isLoading}
                  dataSource={[]}
                  columns={columns}
                  handleResize={handleResize}
                />
              )}
            </div>
            <TemplateReportModal ref={templateReportModalRef} {...templateReportModalProps} />
          </div>
        </Wrapper>
      </div>
    );
  });
}
